import {useState, useEffect} from 'react'
import {
  Navigate,
  useNavigate
} from "react-router-dom";
import {
	Container,
	Box,
	TextField,
	Button,
	Grid,
	Typography,
	Paper,
	Link
} from '@mui/material'
import {
	LoadingButton
} from '@mui/lab'
import ExitToAppRoundedIcon from '@mui/icons-material/ExitToAppRounded';
import UserService from '../services/UserService'
import AuthContext from '../providers/AuthProvider'

function NotLogin(props) {
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('') 
	const [errors, setErrors] = useState({})
	const [loging, setLoging] = useState(false)
	const navigate = useNavigate()
	const auth = AuthContext.useAuth()

	useEffect(() => {
		resetError()
	}, [])

	function handleEmail(e) {
		setEmail(e.target.value)
		resetError()
	}

	function handlePassword(e) {
		setPassword(e.target.value)
		resetError()
	}

	function resetError() {
		setErrors({
			email: false,
			email_message: '',
			password: false,
			password_message: '',
		})
	}

	async function login() {
		try{
			if( !email.match(/.+?@.+?/) ) {
				setErrors({
					...errors,
					email: true,
					email_message: 'Please enter the correct email'
				})
				return
			}
			if( !password ) {
				setErrors({
					...errors,
					password: true,
					password_message: 'Please enter password'
				})
				return
			}
			setLoging(true)
			const _user = await UserService.login(email, password)
			setLoging(false)
			auth.login(_user)
			navigate('/users')
		} catch(e) {
			setErrors({
				...errors,
				password: true,
				password_message: e.response.data.message
			})
			setLoging(false)
		}
	}

	return <>
		<Container fixed>
			<Grid container sx={{pt: 20}}>
				<Grid item xs={0} sm={2} lg={3}></Grid>
				<Grid item xs={12} sm={8} lg={6}>
					<Paper sx={{p: 3, pb:4}}>
						<Typography variant="h5">
							Retail ORBIT®
						</Typography>
						<Typography variant="subtitle1" sx={{mb:3}}>
							Login to your account
						</Typography>
						<TextField 
							fullWidth
							label="Email Address"
							value={email}
							name="email"
							onChange={handleEmail}
							error={errors.email}
							helperText={errors.email_message}
							sx={{backgroundColor: 'white'}}
						/>
						<TextField 
							fullWidth
							label="Password"
							type='password'
							value={password}
							name="password"
							onChange={handlePassword}
							error={errors.password}
							helperText={errors.password_message}
							sx={{mt: 2, backgroundColor: 'white'}}
						/>
						<LoadingButton
							variant="contained"
							loading={loging}
							color='primary'
							sx={{mt: 2, mb: 2}}
							fullWidth
							size="large"
							onClick={login}
							startIcon={<ExitToAppRoundedIcon />}
						>
							Sign In
						</LoadingButton>
						<Link
							href="forgot-password"
							underline="hover"
							sx={{ textTransform: 'uppercase'}}
						>
							forgot password?
						</Link>
					</Paper>
				</Grid>
			</Grid>
		</Container>
	</>
}

export default NotLogin